// extracted by mini-css-extract-plugin
export default {"list":"BMU5JP","item":"mENCXR","empty":"cEFxrf","emptyButton":"aslQ4B"};